module.exports = __webpack_public_path__ + "img/icon-close.777b93c6.svg";